import React from 'react';
import Typography from './Typography';

const CustomTextarea = ({
  label,
  placeholder,
  required = false,
  name,
  id,
  value,
  onChange,
  maxLength,
  rows = 5,
  ...props
}) => {
  return (
    <div className="custom-textarea-container">
      <div className="custom-textarea-label">
        <Typography size="14px" color="#FFF" text={label} />
        {required && (
          <span className="required-text">
            <Typography size="14px" color="#DF0F11" text="* REQUIRED" />
          </span>
        )}
      </div>
      <div className="custom-textarea-wrapper">
        <textarea
          name={name}
          id={id}
          value={value}
          onChange={onChange}
        //   placeholder={placeholder}
          className="custom-textarea-field"
          rows={rows}
          maxLength={maxLength}
          required={required}
          {...props}
        />
        {value.length === 0 && (
          <div className="custom-textarea-placeholder">
            <Typography size="14px" color="#FFF" text={placeholder} opacity={'0.3'} />
            <Typography size="14px" color="#DF0F11" text="*max 2000 characters" opacity={'0.3'} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomTextarea;